import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetFormingSessionById } from 'api/queries/forming-sessions/forming-sessions';
import { EMPTY_GUID } from 'shared/constants';

export const useGetBuildingModel = () => {
    const [searchParams] = useSearchParams();

    const sessionguid = useMemo(
        () => searchParams.get('formingsession') ?? EMPTY_GUID,
        [searchParams]
    );

    const queryKey = useMemo(() => ['building', sessionguid], [sessionguid]);

    const {
        data: buildingModel,
        isPending: isGetFormingSessionByIdPending,
        error
    } = useGetFormingSessionById(sessionguid, { query: { queryKey, staleTime: 24 * 60 * 60 * 1000 } });

    if (error) {
        throw error;
    }

    return {
        sessionguid,
        buildingModel: buildingModel?.data,
        isGetFormingSessionByIdPending
    };
};
